import React, { useState, useRef, useEffect } from "react";
import { Box, IconButton, Paper } from "@mui/material";
import Modal from "@mui/material/Modal";
import CancelIcon from "@mui/icons-material/Cancel";
import { Padding } from "./Padding";
import { StorageHelper } from "../../helpers";
import Cookies from "js-cookie";

const style = {
  position: "absolute",
  padding: "16px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90vw",
  boxShadow: 24,
  // overflowY: "scroll",
};

export const MgpSeesionTimeOutWarning = ({
  styling,
  open,
  onClose = () => {},
}) => {
  // We need ref in this, because we are dealing
  // with JS setInterval to keep track of it and
  // stop it when needed
  const Ref = useRef(null);

  // The state for our timer
  const [timer, setTimer] = useState("00:00");
  const [isStart, setStart] = useState(open);

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / 1000 / 60 / 60) % 24);
    return {
      total,
      hours,
      minutes,
      seconds,
    };
  };

  const startTimer = (e) => {
    let { total, hours, minutes, seconds } = getTimeRemaining(e);
    if (isStart) {
      if (total >= 0) {
        // update the timer
        // check if less than 10 then we need to
        // add '0' at the beginning of the variable
        setTimer(
          // (hours > 9 ? hours : "0" + hours) +
          //   ":" +
          (minutes > 9 ? minutes : "0" + minutes) +
            ":" +
            (seconds > 9 ? seconds : "0" + seconds)
        );
      }
      if (total === -1000) {
        StorageHelper.remove("subinvestigator_id");
        StorageHelper.remove("sub_investigator");
        StorageHelper.remove("user");
        StorageHelper.remove("default_page");
        StorageHelper.remove("assigned_hospitals");
        StorageHelper.remove("token");
        StorageHelper.remove("default_page");
        StorageHelper.clear();
        Cookies.remove("userMgpr");
        window.location.href = "/login";
      }
    }
  };

  const clearTimer = (e) => {
    // If you adjust it you should also need to
    // adjust the Endtime formula we are about
    // to code next
    setTimer("01:00");

    // If you try to remove this line the
    // updating of timer Variable will be
    // after 1000ms or 1sec
    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id;
  };

  const getDeadTime = () => {
    let deadline = new Date();

    // This is where you need to adjust if
    // you entend to add more time
    deadline.setSeconds(deadline.getSeconds() + 60);
    return deadline;
  };

  // We can use useEffect so that when the component
  // mount the timer will start as soon as possible

  // We put empty array to act as componentDid
  // mount only
  useEffect(() => {
    clearTimer(getDeadTime());
  }, []);

  // Another way to call the clearTimer() to start
  // the countdown is via action event from the
  // button first we create function to be called
  // by the button
  const onClickReset = () => {
    clearTimer(getDeadTime());
  };

  return (
    <div>
      <Modal
        xs={{ minHeight: "30%" }}
        open={true}
        // onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper sx={{ ...style, ...styling, width: "43%" }}>
          <Box
            sx={{
              marginBottom: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <h4 style={{ color: "red" }}>Attention!</h4>
          </Box>
          <Box sx={{ overflowY: "auto", maxHeight: "80vh" }}>
            <Padding size="8px 0px">
              <div style={{ textAlign: "center", margin: "auto" }}>
                {/* <h1 style={{ color: "green" }}>GeeksforGeeks</h1> */}
                <h6>
                  Your current session will be automatically logged out in
                </h6>
                <h2>{timer}</h2>
                {/* <br />
                <button onClick={onClose}>Close</button> */}
              </div>
            </Padding>
          </Box>

          <IconButton
            onClick={() => {
              // console.log("william", 1);
              clearTimer(undefined);
              setStart(false);
              onClose();
            }}
            sx={{
              marginBottom: "30px",
              marginLeft: "24px",
              position: "absolute",
              top: 6,
              right: 20,
            }}
          >
            <CancelIcon />
          </IconButton>
        </Paper>
      </Modal>
    </div>
  );
};
